"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OidcIdToken = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _OidcToken = require("./OidcToken");
class OidcIdToken extends _OidcToken.OidcToken {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "preferredUsername", this.getClaim('urn:oriflame:activeDirectory:preferred_username'));
    (0, _defineProperty2.default)(this, "name", this.getClaim('name'));
  }
}
exports.OidcIdToken = OidcIdToken;
//# sourceMappingURL=OidcIdToken.js.map